if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        try {
          // First, get the current cart contents
          const cartResponse = await fetch(`${routes.cart_url}.js`);
          const cart = await cartResponse.json();

          // Get the form data
          const formData = new FormData(this.form);
          const variantId = formData.get("id");
          const sellingPlanId = formData.get("selling_plan");
          const quantity = Number(formData.get("quantity") || 1);

          // Look for an existing item with the same variant and selling plan
          const existingItem = cart.items.find(
            (item) =>
              item.variant_id.toString() === variantId.toString() &&
              ((!sellingPlanId && !item.selling_plan_allocation) ||
                (item.selling_plan_allocation &&
                  item.selling_plan_allocation.selling_plan.id.toString() === sellingPlanId?.toString()))
          );

          // Prepare the request
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          if (existingItem) {
            // Update existing item quantity
            const updateFormData = new FormData();
            updateFormData.append("id", existingItem.key);
            updateFormData.append("quantity", existingItem.quantity + quantity);

            if (this.cart) {
              updateFormData.append(
                "sections",
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              updateFormData.append("sections_url", window.location.pathname);
            }

            config.body = updateFormData;
            const response = await fetch(`${routes.cart_change_url}`, config);
            const parsedResponse = await response.json();

            if (parsedResponse.status) {
              this.handleErrorMessage(parsedResponse.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            this.cart.renderContents(parsedResponse);
          } else {
            // Add new item
            if (this.cart) {
              formData.append(
                "sections",
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append("sections_url", window.location.pathname);
            }

            config.body = formData;
            const response = await fetch(`${routes.cart_add_url}`, config);
            const parsedResponse = await response.json();

            if (parsedResponse.status) {
              this.handleErrorMessage(parsedResponse.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            this.cart.renderContents(parsedResponse);
          }
        } catch (e) {
          console.error(e);
          this.handleErrorMessage(e.message);
        } finally {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add("hidden");
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
